import { customizeError, getLogger } from '@chilecompra/react-kit'
import Cookie from 'js-cookie'

import { isLocalEnv } from '../config/settings/environment.config'

const logger = getLogger('Cookies')

/**
 * To get a value from cookie domain mercadopublico.
 */
export const getCookieFromDomain = (key, options = {}) => {
  try {
    const cookieOptions = !isLocalEnv ? { domain: '.mercadopublico.cl' } : {}

    let entry = Cookie.get(key, cookieOptions)

    if (!entry) {
      return null
    }

    if (entry && options.base64) {
      entry = window.atob(entry)
    }

    if (entry && options.json) {
      entry = JSON.parse(entry)
    }

    return entry
  } catch (error) {
    logger.warn(`Unable to get data from cookie ${key}`, error)

    throw customizeError({
      originalError: error,
      reason: 'GET_COOKIE_ERROR'
    })
  }
}
